import { xenn } from './index';

export default {
  profile() {
    return xenn.get('/profile');
  },
};
